module.exports = __webpack_public_path__ + "img/s-2.f0da647c.svg";